const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const EditPencil = require("../EditPencil");
const styles = require("./styles/Gifting.css");

module.exports = createReactClass({
	displayName: "GiftRecipientInfo",
	propTypes: {
		recipientEmail: PT.string,
		senderName: PT.string,
		studentName: PT.string,
		deliveryDate: PT.oneOfType([PT.instanceOf(Date), PT.string]),
		personalizedMessage: PT.string,
		onEdit: PT.func,
	},

	getInitialState: function() {
		return {
			isModalOpen: false,
		};
	},

	render: function() {
		return (
			<div>
				<div className={styles.recipientInfoContainer}>
					<div>
						<div className={styles.recipientFieldName}>Recipient Email</div>
						<div className={styles.name}>{this.props.recipientEmail}</div>
					</div>
					<div>
						<div className={styles.recipientFieldName}>From</div>
						<div className={styles.name}>{this.props.senderName}</div>
					</div>
					<div>
						<div className={styles.recipientFieldName}>To</div>
						<div className={styles.name}>{this.props.studentName || "---"}</div>
					</div>
					<div className={styles.editButton} onClick={this.props.onEdit}>
						<EditPencil />
						Edit
					</div>
				</div>
			</div>
		);
	},
});
